import React from 'react'
import {Table, Checkbox} from 'antd'
import {decode} from 'utf8'

const TableNotify = ({dataSource, onPressCheck, tokensSelected}) => {
  const columns = [
    {
      title: 'Cédula',
      dataIndex: 'identifier',
      key: 'identifier',
      render: text => <span>{decode(text)}</span>,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      render: text => <span>{decode(text)}</span>,
    },
    {
      title: 'Correo',
      dataIndex: 'email',
      key: 'email',
      render: text => <span>{decode(text)}</span>,
    },
    {
      title: 'Acción',
      key: 'action',

      render: (text, record) => (
        <button className="checkbox" onClick={() => onPressCheck(record)}>
          {tokensSelected.includes(record.token) ? (
            <i className="gx-icon icon icon-check" />
          ) : null}
        </button>
      ),
    },
  ]

  return (
    <Table
      className="gx-table-responsive"
      columns={columns}
      dataSource={dataSource}
    />
  )
}

export default TableNotify



// WEBPACK FOOTER //
// ./src/routes/main/Notifications/TableNotify.js